import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MaintenanceDashboard from './MaintenanceDashboard';
import TicketForm from './components/TicketForm';
import TicketDetail from './components/TicketDetail';

const Maintenance = () => {
  // Mock user data - replace with actual user context/auth
  const user = {
    id: 'USER123',
    name: 'John Doe',
    department: 'Operations',
    role: 'MAINTENANCE_MANAGER'  // Set to MAINTENANCE_MANAGER to see admin settings
  };

  return (
    <Routes>
      <Route index element={<MaintenanceDashboard user={user} />} />
      <Route path="new-ticket" element={<TicketForm user={user} onSubmit={async (data) => {
        console.log('Submitting ticket:', data);
        return Promise.resolve(data);
      }} />} />
      <Route path="ticket/:id" element={<TicketDetail />} />
    </Routes>
  );
};

export default Maintenance; 